import React, { useState, useMemo, useCallback } from 'react';

import { subDays, format } from 'date-fns';

import { Report } from '~/components';
import { DateTime, RadioGroup, Autocomplete } from '~/components/Form';
import { t } from '~/helpers';

export default function RelPrecoProduto() {
  const [open, setOpen] = useState(true);
  const [product, setProduct] = useState('');

  const dateTime = useMemo(
    () => ({
      start: format(subDays(new Date(), 7), 'dd/MM/yyyy 00:00:00'),
      end: format(new Date(), 'dd/MM/yyyy 23:59:59'),
    }),
    []
  );

  const exports = useMemo(
    () => [
      { label: 'PDF', value: 'pdf' },
      { label: 'Excel', value: 'excel' },
    ],
    []
  );

  const handleSerializeFormData = useCallback(
    (data) => ({
      ...data,
      nomeproduto: data.idproduto ? product : '',
    }),
    [product]
  );

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title={t('s.menu.relatorio.historicoprecoproduto')}
      relatorio="relhistoricoprecoproduto"
      serialize={handleSerializeFormData}
      initials={{
        datahorainicial: dateTime.start,
        datahorafinal: dateTime.end,
        formato: 'pdf',
      }}
    >
      <DateTime
        time
        name="datahorainicial"
        label={t('s.geral.opcoes.datahorainicial')}
      />

      <DateTime
        time
        name="datahorafinal"
        label={t('s.geral.opcoes.datahorafinal')}
      />

      <Autocomplete
        name="idproduto"
        label="nomeabreviadoproduto"
        url="produtos"
        unique="idproduto"
        title={t('s.menu.configuracao.produto')}
        getValue={(value) => setProduct(value.nomeproduto || '')}
      />

      <RadioGroup
        row
        name="formato"
        label={t('s.relatorio.geral.formato')}
        options={exports}
        serialize={(value) => value}
      />
    </Report>
  );
}
